/**
 * Detail 座位状态信息
 * props:
 *
 */
import React from 'react';
import styles from './style/index.less';
import {TLang, ReplaceText, getCookie} from '@/utils/lang';
const Detail = (e) => (
  // 单 可选 已售 情侣座   多  已售 情侣座
  <div className={styles.detail}>
    {
      e.single?<div style={getCookie('df_lang')==='en-US'?{marginRight:'35px'}:{}}><b className={styles.empty}></b>{TLang('可选', 'home', false, false, null)}</div>:null
    }
    <div><b className={styles.sited}></b>{TLang('已售', 'home', false, false, null)}</div>
    {
      e.love ? <div><b className={styles.love}></b>{TLang('情侣座', 'home', false, false, null)}</div> :null
    }
  </div>
);
export default React.memo(Detail, (c, n) => false);
